
import { useState } from 'react';
import { motion } from "framer-motion";
import PasswordProtection from "../components/PasswordProtection";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PodAddForm from "../components/PodAddForm";

const PodAdd = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem('podAddAuthenticated') === 'true';
  });

  const handlePasswordSuccess = () => {
    setIsAuthenticated(true);
    localStorage.setItem('podAddAuthenticated', 'true');
  };

  if (!isAuthenticated) {
    return <PasswordProtection onSuccess={handlePasswordSuccess} password="podsforever42" />;
  }

  return (
    <div className="min-h-screen bg-[#f9f8f5]">
      <Header />
      
      <main className="pt-20">
        <div className="max-w-[800px] mx-auto px-4 desktop:px-24 laptop:px-20 tablet:px-12 mobile:px-6 py-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h1 className="text-4xl desktop:text-5xl laptop:text-4xl tablet:text-3xl mobile:text-2xl font-bold text-[#374151] mb-4">
              Add New Pod
            </h1>
            <p className="text-lg text-gray-700 max-w-2xl mx-auto">
              Add a new pod location to the directory
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <PodAddForm />
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PodAdd;
